export default "__VITE_ASSET__CckAVgd9__"